<template>
  <div class="layout-aside">
    <!-- <transition-group name="el-zoom-in-center" tag="ul"> -->
    <ul>
      <li v-for="item in routes" v-show="routes.length" :key="item.path" :class="{ active: item.name === current }">
        <router-link :to="{ name: item.name }">
          {{ item.meta.title }}
        </router-link>
      </li>
    </ul>
    <!-- </transition-group> -->

    <!-- <div class="ad b-mgt">
      <a href="#">
        <ming-image :src="require('@/assets/ad.png')" width="200px" height="276px" />
      </a>
    </div> -->
  </div>
</template>

<script>
// import MingImage from '@/components/MingImage'
export default {
  // components: {
  //   MingImage
  // },
  computed: {
    routes() {
      const activeRouteKey = this.$route.matched[0].name
      const data = this.$router.options.routes.filter(item => {
        if (!item.hidden && item.name === activeRouteKey) {
          return item
        }
      })

      const asideBarRoute = data[0].children.filter(v => !v.meta.hidden)

      return asideBarRoute
    },
    current() {
      const route = this.$route
      const { meta, name } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }

      return name
    }
  }
}

// const activeMenu = computed(() => {
//   const route = this.$route
//   const { meta, path } = route
//   console.log('path', path)

//   // if set path, the sidebar will highlight the path you set
//   if (meta.activeMenu) {
//     return meta.activeMenu
//   }
//   return path
// })
</script>

<style lang="scss" scoped>
.layout-aside {
  width: 200px;
  height: 100%;
  margin-right: 20px;
  // background-color: #ccc;
  ul {
    width: 100%;
    margin: 0;
    border-radius: 8px;
    background-color: #fff;
    padding: 0;
    li {
      list-style: none;
      padding: 0 14px;
      > a {
        display: block;
        width: 100%;
        height: 100%;
        padding: 14px 0;
        color: #777777;
        font-size: 16px;
      }
      &:not(:last-child) {
        a {
          border-bottom: 1px solid #eee;
        }
      }
      &.active {
        // background-color: var(--theme-color);
        a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: var(--theme-color);
          transition: all linear 0.3s;
          &::after {
            content: '';
            display: block;
            width: 0;
            width: 8px;
            height: 11px;
            background-color: var(--theme-color);
            -webkit-clip-path: polygon(0 0, 100% 45%, 0 100%);
clip-path: polygon(0 0, 100% 45%, 0 100%);
            // background-image: url('@/assets/aside-active.png');
            background-size: 100% 100%;
          }
        }
      }
    }
  }
  .ad {
    width: 200px;
    height: 276px;
    background-color: #ccc;
    border-radius: 8px;
  }
}
</style>
